import { useSyncExternalStore } from 'react';

import { getSupportSession, subscribeSupportSession, type SupportSession } from './tokenStorage';

let snapshot: SupportSession | null = null;
let snapshotKey = '';

// Снимок стабилен между вызовами: `useSyncExternalStore` требует тот же объект, пока
// состояние не изменилось, иначе рендер уходит в бесконечный цикл.
function read(): SupportSession | null {
  const current = getSupportSession();
  const key = current ? `${current.targetName}|${current.banner}` : '';
  if (key !== snapshotKey) {
    snapshotKey = key;
    snapshot = current;
  }
  return snapshot;
}

/** Текущая саппорт-сессия платформы или `null` (T-039). */
export function useSupportSession(): SupportSession | null {
  return useSyncExternalStore(subscribeSupportSession, read, read);
}
